<div class="MenuBox" *ngIf="responseReceived | async">
  <!-- Sidebar -->
  <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion SideNavFix" [class.toggled]="classToggled"
    id="accordionSidebar">
    <!-- Nav Item - Pages Collapse Menu -->
    <li class="nav-item">
      <a class="nav-link">
        <span></span>
      </a>
    </li>

    <li *ngFor="let menuitem of leftNavItems; index as i;" class="nav-item">

      <ng-template [ngIf]="menuitem.children.length==0" [ngIfElse]="hasSubMenu">
        <ng-container [ngSwitch]="menuitem.componentTypeID">
          <ng-container *ngSwitchCase="1">
            <a
              class="nav-link"
              draggable="false"
              (drag)="itemDragged($event)"
              [routerLink]="componentHeirarchyLevel == 71 ? [menuitem.componentUrl] : (componentHeirarchyLevel == 99 ? [menuitem.componentUrl] : [menuitem.componentUrl])"
              [ngClass]="{
                'SideNavActiv': isMenuChildActive(menuitem)
              }"
              (click)="menuItemClicked(menuitem)"
            >
              <i [ngClass]="menuitem.componentIcon"></i>
              <span>{{menuitem.componentName}}</span>
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <a
              class="nav-link"
              (click)="navigateInNewTab(menuitem)"
              style="cursor: pointer;"
            >
              <i [ngClass]="menuitem.componentIcon"></i>
              <span>{{menuitem.componentName}}</span>
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="3">
            <a
              class="nav-link"
              draggable="false"
              (drag)="itemDragged($event)"
              [href]="componentHeirarchyLevel == 71 ? [menuitem.componentUrl] : (componentHeirarchyLevel == 99 ? [menuitem.componentUrl] : [menuitem.componentUrl])"
              target="_blank"
              style="cursor: pointer;"
            >
              <i [ngClass]="menuitem.componentIcon"></i>
              <span>{{menuitem.componentName}}</span>
            </a>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <a
              class="nav-link"
              draggable="false"
              (drag)="itemDragged($event)"
              [routerLink]="componentHeirarchyLevel == 71 ? [menuitem.componentUrl] : (componentHeirarchyLevel == 99 ? [menuitem.componentUrl] : [menuitem.componentUrl])"
              routerLinkActive="SideNavActiv"
            >
              <i [ngClass]="menuitem.componentIcon"></i>
              <span>{{menuitem.componentName}}</span>
            </a>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #hasSubMenu>
        <a
          class="nav-link collapsed"
          [ngClass]="{
            'SideNavActiv': isMenuChildActive(menuitem),
            'collapsed': menuitem.componentName!=='Claimants'
          }"
          data-toggle="collapse"
          [attr.data-target]="'#collapse'+i"
          aria-expanded="true"
          attr.aria-controls="collapse{{i}}"
          id="parentMenu{{i}}"
        >
          <i class="" [ngClass]="menuitem.componentIcon"></i>
          <span>{{menuitem.componentName}}</span>
        </a>
        <div id="collapse{{i}}" class="collapse"
          [ngClass]="{
            'show': menuitem.componentName==='Claimants'
          }"
          attr.aria-labelledby="heading{{i}}"
          
        >
          <div class="collapse-inner rounded">
            <a class="collapse-item"
              (click)="submenuitemClicked(submenuitem)"
              [ngClass]="{'SideNavActiv': isSubMenuChildActive(submenuitem)}"
              *ngFor="let submenuitem of menuitem.children"
              [routerLink]="submenuitem.componentUrl"
            >
              {{submenuitem.componentName}}
            </a>
          </div>
        </div>
      </ng-template>
    </li>

    <!-- Sidebar Toggler (Sidebar) -->
    <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" (click)="toggleField()" id="sidebarToggle" aria-label="Toggle"></button>
      <button class="rounded-circle border-0 expandCollapseAll" (click)="collapseExpandAll()" aria-label="Toggle" [title]="isExpandedAll ? 'Collapse All' : 'Expand All'">
        <i class="fa fa-angle-double-down" *ngIf="!isExpandedAll" aria-label="Collapse All"></i>
        <i class="fa fa-angle-double-up" *ngIf="isExpandedAll" aria-label="Expand All"></i>
      </button>
    </div>

  </ul>
</div>
<div *ngIf="!responseReceived">
  <img class="fast-loader" src="assets/img/Kearai-loading-icon.gif" alt="Loader">
</div>
<!-- End of Sidebar -->
